import { css } from "emotion";
import { H3 } from "../../../components/text/TextComponents";
import TabMenu from "../../../components/TabMenu";
import Members from "./Members";
import { Component } from "preact";
import { getSize } from "../../../utils/BrowserUtils";
import ContentBlock from "../../../components/layout/ContentBlock";

//Board Information
const mugLoredana = require("../../../assets/mugs/Board/LoredanaFyffe.jpg");
const mugPhil = require("../../../assets/mugs/Board/PhilMartin.jpg");
const mugGai = require("../../../assets/mugs/Board/Gai.jpg");
const mugJonathan = require("../../../assets/mugs/Board/Jonathan.jpg");
const mugJohn = require("../../../assets/mugs/Ambassadors/mug_john.jpg");
const mugDeb = require("../../../assets/mugs/Board/deb.jpg");

const board = [
  {
    mug: mugGai,
    name: "Gai McGrath",
    title:
      "Director of Investa Office Fund, Steadfast Group, Genworth Mortgage Insurance Australia, IMB Bank and Toyota Finance Australia,  Member of the Council of The State Library of NSW, director and Trustee of the State Library of NSW Foundation, member of the Salvation Army’s Appeals and Fundraising Committee",
    blurb:
      "Gai McGrath is a professional company director. Gai is able to draw on over 32 years experience in leading businesses and the legal profession to help organisations thrive and grow. Gai is excited about the opportunity to contribute to Humanitix as it pursues its bold goal to positively change the world one ticket at a time."
  },
  {
    mug: mugLoredana,
    name: "Loredana Fyffe",
    title: "Communications & Giving Leader, Sydney Community Foundation",
    blurb:
      "Loredana has 13 years experience in philanthropy and fundraising and was instantly inspired by Humanitix’s innovative fundraising model. “I believe not-for-profits globally need to diversify their income streams, Humanitix’s intelligent social enterprise solution creates a fundraising stream in perpetuity for those most in need in our communities. We are enabling social impact from event organisers at no cost and empowering event-goers to purchase tickets knowing they are doing good.”"
  },
  {
    mug: mugJonathan,
    name: "Jonathan Rubinsztein",
    title: "Chief Executive Officer (CEO) & Managing Director at Infomedia",
    blurb:
      "Jonathan is the CEO and Managing Director of Infomedia Ltd, a leading global provider of SaaS solutions to the parts and service sector of the automotive industry. He is also a non-executive director of Missionvale Australia (a charity supporting the extremely poor township in South Africa). His focus & expertise are around enabling business growth specifically in Sales and Marketing, Mergers and Acquisitions, Executive Leadership, Alliances and Strategy. Jonathan is a newly appointed Board Member with Humanitix and is excited to be involved and support the growth of the business."
  },
  {
    mug: mugDeb,
    name: "Deborah Thomas",
    title: "CEO (ASX 150), Media Executive, Non-Executive Director",
    blurb:
      "Deborah is regarded as one of Australia’s most successful and respected media executives, with over 25 years’ experience across print, television, radio, digital and social media. She has managed some of Australia’s most popular magazine brands including Editor-in-Chief of The Australian Women’s Weekly, a position she held for almost a decade. Deborah is a founding patron of the Taronga Conservation Foundation and current Chair of the Ensemble Theatre Foundation. "
  }
];

//Advisor Information
const mugLouise = require("../../../assets/mugs/Advisors/LouiseMcElvogue.jpg");
const mugPeter = require("../../../assets/mugs/Advisors/PeterColosimo.jpg");
const mugSamuel = require("../../../assets/mugs/Advisors/SamuelHamrosi.jpg");
const mugAlana = require("../../../assets/mugs/Advisors/AlanaSudale.jpg");

const advisors = [
  {
    mug: mugLouise,
    name: "Louise McElvogue",
    title: "Principal Macleod Media, Independent Board Director",
    blurb:
      "Louise has global experience as an executive, board member and consultant. Louise started her career as a journalist, before moving into digital where she has worked on more than 30 transformation projects for companies including McDonald's, British Gas, Fairfax Media, BBC and Channel 4. Louise was a member of the Convergence Review Committee, which reviewed media and internet regulation for the Australian Federal Government. Her board roles include WhiteHawk, APA, Sydney Living Museums, Australian Institute of Company Directors NSW Council, Chair of the UTS Faculty of Arts and Social Sciences Advisory Board. "
  },
  {
    mug: mugPeter,
    name: "Peter Colosimo",
    title:
      "Group General Manager & Executive Leader for Australia’s Leading Entertainment company NOVA Entertainment",
    blurb:
      "Growing up in a family of business pioneers, Peter learnt the craft of putting people first to deliver business success. People leadership has shaped his progression through sales leadership whilst building a passion for investing in his personal time. “Always placing people first in my approach, leading with respect and honesty – I care deeply about the relationships I make and hold, and believe strongly in the pursuit of the common good to achieve progressive business outcomes and I see Humanitix as the perfect combination of innovative business with supporting people in need at the heart of its inspiration and delivery”. Peter is here to support the media and communication of the Humanitix story throughout the market."
  },

  {
    mug: mugSamuel,
    name: "Samuel Hamrosi",
    title: "Director at Kingdom Developments Australia",
    blurb:
      "Samuel is a successful entrepreneur, philanthropist and investor having started/funded over eight companies since 2001 including Schnitz, Humanitix, IVB Exports (Japan), Scancam, Vanity Bar, Santa & Friends (Japan), Future You Summit and Kingdom Developments. The three organisations he is most passionate about currently are Humanitix, Future You Summit & Kingdom Developments."
  },
  {
    mug: mugPhil,
    name: "Phil Martin",
    title: "Managing Director, Martin IT",
    blurb:
      "Phil is a qualified Enterprise Architect and has extensive senior management, scrum mastering and delivery management experience. He has a history of delivering projects and partnering with businesses to ensure their success, through his software agency, Martin IT. He has worked at multiple levels across the IT Development hierarchy, and believes in constant learning and adaptation being the keys to success. Phil was introduced to Humanitix in 2016, and his team at Martin IT helped build Humanitix’s first web presence. He has been an avid supporter ever since."
  },
  {
    mug: mugAlana,
    name: "Alana Sudale",
    title: "Managing Director, Sudale Communications",
    blurb:
      "Alana Sudale is a senior communications professional with 14 years’ experience working in Public Relations, Marketing, Advertising and Events Management across the not-for-profit, entertainment and lifestyle sectors. She is an effective strategist and has been integral in building brand and executive profiles in the Australian and New Zealand markets. A born networker at heart, Alana is passionate about supporting Humanitix to spread its message far and wide, literally changing the world one ticket at a time."
  }
];

const ambassadors = [
  {
    mug: mugJohn,
    name: "John Eales",
    title:
      "Board Director - Flight Centre Travel Group, Fuji Xerox-DMS, The Palladium Group and Magellan Financial Group",
    blurb:
      "John Eales AM is regarded as one of the greatest rugby players Australia has ever produced. His outstanding qualities extend much further than his exceptional skill on the football field. He is an inspirational leader and businessman through both his actions and his relentless determination. John’s sense of fair play and genial nature made him one of the most respected figures in the game, and an extraordinary ambassador for sport and Australia.\nJohn was the founder of the Mettle Group – a consultancy which was acquired by Chandler Macleod in 2007, and sits on the boards of Flight Centre Travel Group, Fuji Xerox-DMS, Magellan Financial Group and The Palladium Group. He is a columnist with The Australian Newspaper, has also been an occasional lecturer at the University of Notre Dame in Sydney and is the author of “Learning from Legends - Sport” and “Learning from Legends - Business”."
  }
];

const tabs = [
  {
    heading: "Ambassadors",
    content: <Members people={ambassadors} key={ambassadors} />
  },
  {
    heading: "Board",
    content: <Members people={board} key={board} />
  },
  {
    heading: "Advisors",
    content: <Members people={advisors} key={advisors} />
  }
];

const wrapper = css({
  maxWidth: 860,
  margin: "0 auto",
  "@media(max-width: 600px)": {
    padding: "30px 0px"
  }
});

class BoardAdvisors extends Component {
  constructor(props) {
    super(props);
    const size = getSize();
    let desktopVersion = size.innerWidth > 600 ? true : false;
    this.state = {
      desktopVersion: desktopVersion
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    const isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      window.addEventListener("resize", this.handleResize, { passive: true });
    }
  }

  componentWillUnmount() {
    const isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  handleResize(event) {
    const { desktopVersion } = this.state;
    const size = getSize();
    let newDesktopVersion = size.innerWidth > 600 ? true : false;
    if (newDesktopVersion !== desktopVersion) {
      this.setState({
        desktopVersion: newDesktopVersion
      });
    }
  }

  render() {
    const { desktopVersion } = this.state;
    return (
      <ContentBlock color="grey">
        <div className={wrapper} id="ambassador">
          <TabMenu
            tabs={tabs}
            defaultTab={0}
            maxMenuWidth={desktopVersion ? 460 : 320}
          />
        </div>
      </ContentBlock>
    );
  }
}
export default BoardAdvisors;
